import React from 'react';

const variants = {
  yellow: 'bg-yellow-600/20 text-yellow-400 border-yellow-600/30',
  green: 'bg-green-600/20 text-green-400 border-green-600/30',
  red: 'bg-red-600/20 text-red-400 border-red-600/30',
  orange: 'bg-orange-600/20 text-orange-400 border-orange-600/30',
  blue: 'bg-blue-600/20 text-blue-400 border-blue-600/30',
  gray: 'bg-gray-700/50 text-gray-400 border-gray-600/30',
};

export default function Badge({ children, variant = 'gray', className = '' }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
}
